import { createActionGroup, props } from '@ngrx/store';
import { ConfiguredApplication } from './device-configured-applications.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ConfiguredApplicationsResolverActions = createActionGroup({
  source: 'Configured Applications Resolver',
  events: {
    'Configured Applications requested': props<{ deviceIds: string[] }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ConfiguredApplicationsApiActions = createActionGroup({
  source: 'Configured Applications API',
  events: {
    'Configured Applications loaded': props<{ configuredApplications: ConfiguredApplication[] }>(),
    'Configured Applications loaded error': props<{ error: ErrorModel }>(),
  },
});
